/**
 * ChatsViewContent - Contenido de la vista de chats
 * Separado para que useChats() solo se ejecute cuando esta vista está activa
 */

import { useState } from 'react'
import { useChats } from '../../hooks/useChats'
import ChatList from '../chat/ChatList'
import ChatWindow from '../chat/ChatWindow'
import ProspectPanel from '../prospect/ProspectPanel'
import FilterPanel from '../layout/FilterPanel'
import useCRMStore from '../../store/useCRMStore'

export default function ChatsViewContent() {
  const { chats } = useChats()
  const isProspectPanelCollapsed = useCRMStore(state => state.isProspectPanelCollapsed)
  const toggleProspectPanel = useCRMStore(state => state.toggleProspectPanel)
  const [selectedChat, setSelectedChat] = useState(null)

  return (
    <div className="flex flex-1 h-full relative">
      {/* Columna 2 - Filtros (auto-collapse on hover) */}
      <FilterPanel />

      {/* Columna 3 - Lista de Chats */}
      <aside className="w-96 bg-chat-bg border-r border-gray-200 flex flex-col flex-shrink-0">
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Chats</h2>
          <p className="text-sm text-gray-500">{chats.length} conversaciones</p>
        </div>

        <ChatList
          selectedChatId={selectedChat?.id}
          onSelectChat={setSelectedChat}
        />
      </aside>

      {/* Columna 4 - Ventana de Chat */}
      <ChatWindow selectedChat={selectedChat} />

      {/* Columna 5 - Prospect Panel con animación suave */}
      <div
        className={`
          flex-shrink-0 bg-white flex flex-col overflow-hidden
          transition-all duration-300 ease-out
          ${!isProspectPanelCollapsed
            ? 'w-[420px] border-l border-gray-200 shadow-xl'
            : 'w-0'
          }
        `}
      >
        <ProspectPanel
          contact={selectedChat}
          onClose={toggleProspectPanel}
          onUpdate={(phone, changes) => {
            setSelectedChat(prev => {
              if (!prev) return prev
              const updates = {}
              if (changes.assigned_to) updates.assignedTo = changes.assigned_to
              return { ...prev, ...updates }
            })
          }}
          mode="chat"
        />
      </div>

      {/* Botón flotante para reabrir panel - Estilo Koomo */}
      {isProspectPanelCollapsed && (
        <button
          onClick={toggleProspectPanel}
          className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-24 bg-gradient-to-b from-primary-500 to-primary-600 text-white rounded-l-xl flex items-center justify-center hover:from-primary-600 hover:to-primary-700 transition-all shadow-lg z-10 group"
          title="Abrir panel de prospecto"
        >
          <svg className="w-4 h-4 transform group-hover:-translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      )}
    </div>
  )
}
